/**
 * Domains blocked from signup.
 *
 * Intentionally excludes legitimate providers (gmail, outlook, yahoo, etc.).
 * Covers:
 *  - Automated testing services (e.g. Ghost Inspector)
 *  - Disposable / temporary email services
 *  - Known spam-relay domains
 */
const BLOCKED_DOMAINS = [
  // --- Testing / QA services ---
  'mail.ghostinspector.com',
  'ghostinspector.com',
  'mailosaur.com',
  'mailosaur.net',
  'mailosaur.io',

  // --- Disposable / temp email ---
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'guerrillamail.com',
  'guerrillamail.info',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.de',
  'guerrillamail.biz',
  'grr.la',
  'sharklasers.com',
  'guerrillamailblock.com',
  'spam4.me',
  'yopmail.com',
  'yopmail.fr',
  'cool.fr.nf',
  'jetable.fr.nf',
  'nospam.ze.tc',
  'nomail.xl.cx',
  'mega.zik.dj',
  'speed.1s.fr',
  'courriel.fr.nf',
  'moncourrier.fr.nf',
  'monemail.fr.nf',
  'monmail.fr.nf',
  'trashmail.com',
  'trashmail.me',
  'trashmail.org',
  'trashmail.net',
  'trashmail.at',
  'trashmail.io',
  'trashmail.xyz',
  'trash-mail.com',
  'trashmailer.com',
  'getairmail.com',
  'filzmail.com',
  'filzmail.de',
  'tempmail.com',
  'temp-mail.org',
  'tempr.email',
  'tempemail.com',
  'tempinbox.com',
  'tempinbox.net',
  'mytemp.email',
  'mohmal.com',
  'dispostable.com',
  'disposemail.com',
  'discard.email',
  'maildrop.cc',
  'getnada.com',
  'spamex.com',
  'spamgob.com',
  'spamoff.de',
  'spamobox.com',
  'spam.la',
  'spamfree24.org',
  'spamgourmet.com',
  'spamgourmet.net',
  'spamgourmet.org',
  'fakeinbox.com',
  'fake-box.com',
  'fakemailgenerator.net',
  'dodgit.com',
  'maileater.com',
  'mailnesia.com',
  'mailnull.com',
  'mailscrap.com',
  'mailexpire.com',
  'mailforspam.com',
  'rejectmail.com',
  'despam.it',
  'byom.de',
  'binkmail.com',
  'meltmail.com',
  'throwam.com',
  'throwam.net',
  'tempomail.fr',
  'wegwerfmail.de',
  'wegwerfmail.net',
  'wegwerfmail.org',
  'bouncr.com',
  '10minutemail.com',
  '10minutemail.net',
  '10minutemail.co.za',
  '20minutemail.com',
  '20minutemail.it',
];

const BLOCKED_DOMAINS_SET = new Set(BLOCKED_DOMAINS);

/**
 * Returns true if the email's domain is on the blocked list.
 * @param {string} email
 * @returns {boolean}
 */
export function isBlockedEmailDomain(email) {
  if (!email || !email.includes('@')) return false;
  const domain = email.split('@').pop().toLowerCase().trim();
  return BLOCKED_DOMAINS_SET.has(domain);
}
